import React from "react";
// Scss
import "./projectBox.scss";

const projectBox = (props) => (
  <div className="portfolio__box">
    <a href={props.link ? props.link : null} target="_blank" rel="noopener noreferrer">
      <img src={props.preview} alt="project" />
      <div className="portfolio__hover-info flex-center">
        <div className="text-center">
          <p className="font30 weight800">{props.title}</p>
          <p className="font12 weight500 tag-text">{props.tag}</p>
          <p className="font12 weight500">{props.status ? props.status : null}</p>
        </div>
      </div>
    </a>
  </div>
);

export default projectBox;
